import { defineStore } from "pinia";
import _ from "lodash";
import type { Company, Brand } from "@Shared";
import type { Location } from "@Shared";

export const useCompanyStore = defineStore("company", {
    state: () => ({
        company: null as Company | null,
        brand: null as Brand | null,
        companyLocations: [] as Location[],
    }),

    actions: {
        setCompany(newCompany: Company) {
            this.company = newCompany;
        },
        setBrand(newBrand: Brand | null) {
            this.brand = newBrand;
        },
    }
});
